import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPValuePropsModalUI from './PDPValuePropsModalUI';
const PDPValuePropsModal = t0 => {
  const $ = _c(2);
  const {
    itemId
  } = t0;
  let t1;
  if ($[0] !== itemId) {
    t1 = <PDPValuePropsModalUI itemId={itemId} />;
    $[0] = itemId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
PDPValuePropsModal.propTypes = {
  itemId: PropTypes.string
};
export default PDPValuePropsModal;